import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { MatDialog, MatDialogRef } from '@angular/material';
import { LoaderComponent } from './loader.component';

/**
 * Este servicio de loader implemeta el spinner de material
 */
@Injectable()
export class LoadService {

    constructor(
        private dialog: MatDialog
    ) { }

    createLoad(texto?: string): LoadingModal {
        return new LoadingModal(this.dialog, texto)
    }

}

export class LoadingModal {
    private obsText: BehaviorSubject<string>

    private dialog: MatDialog
    private refDialog: MatDialogRef<LoaderComponent>

    constructor(dialogn: MatDialog, text?: string) {
        this.obsText = new BehaviorSubject(text ? text : "")
        this.dialog = dialogn
    }

    open() {
        this.refDialog = this.dialog.open(
            LoaderComponent,
            {
                disableClose: true,
                // panelClass: ["generald"],
                // data: {
                //     obsT: this.obsText
                // }
            }
        )
    }

    close() {
        if (this.refDialog)
            this.refDialog.close()
    }

    setText(texto: string) {
        this.obsText.next(texto)
    }


}



// WEBPACK FOOTER //
// ./src/app/components/loader/loader.service.ts